import {useContext, useState} from "react";
import GlobalContext from "../context/GlobalContext";
import {Listbox} from '@headlessui/react';
import {CheckIcon, SelectorIcon} from '@heroicons/react/solid';
import { HiClock } from "react-icons/hi";
import UUID from "uuid-v4";
import moment from "moment";

const room = [
    {
        id: 1,
        name: 'BIG ROOM $100'

    },
    {
        id: 2,
        name: 'SMALL ROOM $70'

    },


];

const period = [
    {
        id: 1,
        title: "Daily"

    },
    {
        id: 2,
        title: "Noon"

    },
    {
        id: 3,
        title: "All Day"

    },
];

function classNames(...classes) {
    return classes.filter(Boolean).join(' ')
}

export default function EventModal() {
    const {
        setShowEventModal,

        dispatchCalEvent,
        selectedEvent,
        savedEvents,
        setSelectedEvent
    } = useContext(GlobalContext);
    const [title, setTitle] = useState(selectedEvent ? selectedEvent.title : "");
    const [selectedRoom, setSelectedRoom] = useState(
        selectedEvent ? room.find((r) => r.id === selectedEvent.room.id)
            : room[0]);
    const [selectedPeriod, setSelectedPeriod] = useState(
        selectedEvent ? period.find((p) => p.id === selectedEvent.period.id)
            : period[0]);
    const [description, setDescription] = useState(selectedEvent ? selectedEvent.description : "");
    const labelsClasses = ["bg-red-500", "bg-green-500", "bg-blue-500", "bg-gray-500", "bg-indigo-500", "bg-yellow-500"];
    const [selectedLabel, setSelectedLabel] = useState(
        selectedEvent ? labelsClasses.find((lbl) => lbl === selectedEvent.label)
            : labelsClasses[0]);
    const [start, setStart] = useState(selectedEvent ? savedEvents.filter(e => e.eventId === selectedEvent.eventId)[0].start : null);
    const [end, setEnd] = useState(selectedEvent ? selectedEvent.end : null);


    const handleSubmit = (e) => {
        e.preventDefault();
        let eventId = UUID();
        let newEvents = [];
        let numOfDays = moment.duration(moment(end).diff(moment(start))).asDays();
        for (let i = 0; i <= numOfDays; i++) {
            const calendarEvent = {
                title,
                description,
                label: selectedLabel,
                day: moment(start).add(i, "days").toDate(),  //daySelected.valueOf(),
                id: selectedEvent ? selectedEvent.id : Date.now(),
                room: selectedRoom,
                start: new Date(moment(start).add(i, "days").toDate()),
                end,
                eventId: selectedEvent ? selectedEvent.eventId : eventId,
                period:selectedPeriod
            };
            newEvents.push(calendarEvent);
        }


        dispatchCalEvent({type: selectedEvent ? 'update' : 'push', payload: newEvents});

        setShowEventModal(false);
    }
    return (
        <div className=" absolute z-10 h-screen w-full  left-0 top-0 flex flex-rows-4 gap-4 justify-center items-center">
            <form className="bg-white rounded-lg shadow-2xl w-1/4">
                <div className="item-center">
                    
                <header className="bg-gray-100 px-4 py-2 flex justify-between items-center">
                    <span className="">
                        
                    </span>
                    <div>
                        {selectedEvent && (
                            <span
                            className="material-icons-outlined text-gray-400 cursor-pointer"
                                onClick={() => {
                                    dispatchCalEvent({type: "delete", payload: selectedEvent});
                                    setShowEventModal(false);
                                    setSelectedEvent(null)
                                }
                                }

                                >
                        delete
                    </span>
                        )}
                        <button onClick={() => {
                            setShowEventModal(false)
                            setSelectedEvent(null)
                        }}>
                        <span className="material-icons-outlined text-gray-400">
                        close
                    </span>
                        </button>
                    </div>


                </header>
                <div className="p-3">
                    <div className="grid grid-cols-1/5 items-end gap-y-7">
                        <div/>
                        <input
                            type="text"
                            name="title"
                            placeholder="Add event title"
                            value={title}
                            required
                            className="pt-3 border-0 text-gray-600 text-xl font-semibold pb-2 w-1/2 border-b-2 border-gray-200 focus:outline-none focus:ring-0 focus:border-green-500"
                            onChange={(e) => setTitle(e.target.value)}
                        />
                        


                        <div date-rangepicker="" className=" items-center">
                            <div className="relative">
                                <div className="absolute inset-y-0 left-0 flex items-center pl-3 pointer-events-none">
                                    <svg className="w-5 h-5 text-gray-500 dark:text-gray-400" fill="currentColor"
                                         viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
                                        <path fill-rule="evenodd"
                                              d="M6 2a1 1 0 00-1 1v1H4a2 2 0 00-2 2v10a2 2 0 002 2h12a2 2 0 002-2V6a2 2 0 00-2-2h-1V3a1 1 0 10-2 0v1H7V3a1 1 0 00-1-1zm0 5a1 1 0 000 2h8a1 1 0 100-2H6z"
                                              clip-rule="evenodd"/>
                                    </svg>
                                </div>
                                <input name="start" type="date"
                                       className="bg-gray-50 border cursor-pointer border-gray-300 text-gray-900 sm:text-sm rounded-lg focus:ring-green-500 focus:border-green-500 block w-1/3 pl-10 p-2.5   datepicker-input"
                                       placeholder="Select date start"
                                       required
                                       onChange={(e) => setStart(e.target.value)}
                                       value={start}/>
                            </div>
                            <span className="mx-4 text-gray-500">to</span>
                            <div className="relative">
                                <div className="absolute inset-y-0 left-0 flex items-center pl-3 pointer-events-none">
                                    <svg className="w-5 h-5 text-gray-500 dark:text-gray-400" fill="currentColor"
                                         viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
                                        <path fill-rule="evenodd"
                                              d="M6 2a1 1 0 00-1 1v1H4a2 2 0 00-2 2v10a2 2 0 002 2h12a2 2 0 002-2V6a2 2 0 00-2-2h-1V3a1 1 0 10-2 0v1H7V3a1 1 0 00-1-1zm0 5a1 1 0 000 2h8a1 1 0 100-2H6z"
                                              clip-rule="evenodd"/>
                                    </svg>
                                </div>
                                
                                <input name="end" type="date"
                                       className="bg-gray-50 border cursor-pointer border-gray-300 text-gray-900 sm:text-sm rounded-lg focus:ring-green-500 focus:border-green-500 block w-1/3 pl-10 p-2.5  datepicker-input"
                                       placeholder="Select date end"
                                       required
                                       onChange={(e) => setEnd(e.target.value)}
                                       value={end}/>
                            </div>
                        </div>

                        {/* <p> start date {daySelected.format("dddd, MMMM DD")}</p> */}
                        {/*<p> end date {daySelected.format("dddd, MMMM DD")}</p>*/}
                        {/* <span className="material-icons-outlined text-gray-400">
                             segment
                             </span>
                        <input
                        type="text"
                            name="description"
                            placeholder="Add description event"
                            value={description}
                            required
                            className="pt-3 border-0 text-gray-600 text-xl font-semibold pb-2 w-full border-b-2 border-gray-200 focus:outline-none focus:ring-0 focus:border-green-500"
                            onChange={(e) => setDescription(e.target.value)}
                        /> */}

                        <Listbox value={selectedRoom} onChange={setSelectedRoom}>
                            {() => (
                                <>
                                    <Listbox.Label className="block text-sm  text-gray-700 font-bold ">Select Room
                                    </Listbox.Label>
                                    <div className="mt-1 relative">
                                        <Listbox.Button
                                            className=" w-1/3 bg-white border border-gray-300 rounded-md shadow-sm pl-3 pr-10 py-2 text-left cursor-default focus:outline-none focus:ring-1 focus:ring-green-500 focus:border-green-500 sm:text-sm">
              <span className="flex items-center">

                <span className="ml-3 block truncate">{selectedRoom.name}</span>
              </span>
                                            <span
                                                className="ml-3 absolute inset-y-0 right-1/2 flex items-center pr-2 pointer-events-none">
                                                <SelectorIcon className="h-5 w-5 text-gray-400" aria-hidden="true"/>
                                            </span>
                                        </Listbox.Button>


                                        <Listbox.Options
                                            className="absolute z-10 mt-1 w-1/2 bg-white shadow-lg max-h-56 rounded-md py-1 text-base ring-1 ring-black ring-opacity-5 overflow-auto focus:outline-none sm:text-sm transition-duration:5">
                                            {room.map((room) => (
                                                <Listbox.Option
                                                key={room.id}
                                                    required
                                                    className={({active}) =>
                                                    classNames(
                                                        active ? 'text-white bg-green-600' : 'text-gray-900',
                                                            'cursor-default select-none relative py-2 pl-3 pr-9'
                                                        )
                                                    }
                                                    value={room}
                                                    >
                                                    {({selected, active}) => (
                                                        <>
                                                            <div className="flex items-center">

                                                                <span
                                                                    className={classNames(selected ? 'font-semibold' : 'font-normal', 'ml-3 block truncate')}
                                                                >
                            {room.name}
                          </span>
                                                            </div>

                                                            {selected ? (
                                                                <span
                                                                className={classNames(
                                                                    active ? 'text-white' : 'text-green-600',
                                                                        'absolute inset-y-0 right-0 flex items-center pr-4'
                                                                        )}
                                                                >
                            <CheckIcon className="h-5 w-5" aria-hidden="true"/>
                          </span>
                                                            ) : null}
                                                        </>
                                                    )}
                                                </Listbox.Option>
                                            ))}
                                        </Listbox.Options>

                                    </div>
                                </>
                            )}
                        </Listbox>
                        <Listbox value={selectedPeriod} onChange={setSelectedPeriod}>
                            {() => (
                                <>
                                    
                                    <Listbox.Label className="block text-sm  text-gray-700 font-bold ">Select Period
                                    </Listbox.Label>
                                    <div className="mt-1 relative">
                                        <Listbox.Button
                                            className="relative w-1/3 bg-white border border-gray-300 rounded-md shadow-sm pl-3 pr-10 py-2 text-left cursor-default focus:outline-none focus:ring-1 focus:ring-green-500 focus:border-green-500 sm:text-sm">
              <span className="flex items-center">

                <span className="ml-3 block truncate">{selectedPeriod.title}</span>
              </span>
                                            <span
                                                className="ml-3 absolute inset-y-0 right-0 flex items-center pr-2 pointer-events-none">
                <SelectorIcon className="h-5 w-5 text-gray-400" aria-hidden="true"/>
              </span>
                                        </Listbox.Button>


                                        <Listbox.Options
                                            className="absolute z-10 mt-1 w-1/2 bg-white shadow-lg max-h-56 rounded-md py-1 text-base ring-1 ring-black ring-opacity-5 overflow-auto focus:outline-none sm:text-sm transition-duration:5">
                                            {period.map((period) => (
                                                <Listbox.Option
                                                    key={period.id}
                                                    required
                                                    className={({active}) =>
                                                    classNames(
                                                        active ? 'text-white bg-green-600' : 'text-gray-900',
                                                            'cursor-default select-none relative py-2 pl-3 pr-9'
                                                            )
                                                    }
                                                    value={period}
                                                >
                                                    {({selected, active}) => (
                                                        <>
                                                            <div className="flex items-center">

                                                                <span
                                                                    className={classNames(selected ? 'font-semibold' : 'font-normal', 'ml-3 block truncate')}
                                                                    >
                            {period.title}
                          </span>
                                                            </div>

                                                            {selected ? (
                                                                <span
                                                                    className={classNames(
                                                                        active ? 'text-white' : 'text-green-600',
                                                                        'absolute inset-y-0 right-0 flex items-center pr-4'
                                                                        )}
                                                                >
                            <CheckIcon className="h-5 w-5" aria-hidden="true"/>
                          </span>
                                                            ) : null}
                                                        </>
                                                    )}
                                                </Listbox.Option>
                                            ))}
                                        </Listbox.Options>

                                    </div>
                                </>
                            )}
                        </Listbox>
                        
                        <div className="flex gap-x-2">
                            {labelsClasses.map((labelC, i) => (
                                <span key={i}
                                      className={`${labelC} w-6 h-6 rounded-full flex items-center justify-center cursor-pointer`}
                                      onClick={() => setSelectedLabel(labelC)}
                                      >
                                    {selectedLabel === labelC &&
                                    <span className="material-icons-outlined text-sm text-white">
                             check
                        </span>
                                    }



                                </span>
                            ))}
                        </div>

                    </div>
                </div>
                <footer className="flex justify-end  border-t p-3 mt-3">
                    <button type="submit"
                            className="bg-green-600 hover:bg-green-700 px-6 py-2 rounded text-white"
                            onClick={handleSubmit}
                            >
                        Save
                    </button>
                </footer>
            </div>
            </form>

        </div>
    );
}


